import R from 'ramda'
import {defineMessages} from 'react-intl'

import addNotification from './addNotification'

import {listOfLocation2MultiPolygon} from '../utils/location2MultiPolygon'
import getLeafGeographicalZoneIds from '../utils/getLeafGeographicalZoneIds'

import getLocations from '../api/locations'

const messages = defineMessages({
  title: {
    id: 'An error happend', 
    defaultMessage: 'An error happened'
  },
  message: {
    id: "Failed to get the boundaries of the positioning you selected, try again later", 
    defaultMessage: "Failed to get the boundaries of the positioning you selected, try again later"
  }
})

const notification = {type: "error", message: messages.message, title: messages.title}

const onComplete = dispatch => (err, body) => {
  if(err) {
    dispatch(addNotification(notification))
    return console.error("failed to get positioning boundaries", err)
  }
  const boundaries =  listOfLocation2MultiPolygon(body || [])
  dispatch({type: 'show_boundaries', boundaries})
}

export default _ => (dispatch, getState) => {
  const state = getState()
  const ids = getLeafGeographicalZoneIds(state)
  getLocations(ids, onComplete(dispatch))
}



/** WEBPACK FOOTER **
 ** ./app/actions/getPositioningBoundary.js
 **/